import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button, ButtonVariantProps } from '../../components/atoms/Button';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { HorizontalAlignProps, InlineGroup } from '../../components/atoms/InlineGroup';
import { PartTypeList } from './PartTypeList';
import { PageContainer } from '../../components/atoms/PageContainer';
import { useGetUserSystemPermissions } from '../../queries/user-query';
import { ActionPermissions, CustomPermission } from '../../@types';
import { isUserHasPermission } from '../../configs/permissions';
import { Link } from '../../components/atoms/Link';
import { Wrapper } from '../../styled/common.styles';
import { PLATFORM_NAME } from '../../configs/common';
import { TabHandler } from '../../handlers/TabHandler';

export const PartTypes: React.FC = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  TabHandler(`List Part Types | ${PLATFORM_NAME}`);

  return (
    <PageContainer>
      <Wrapper>
        <InlineGroup horizontal={HorizontalAlignProps.Between}>
          <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
            List Part Types
          </Typography>
          {isUserHasPermission(ActionPermissions.Configure_Part_Type_Create, permissions) && (
            <Link href="configure/partTypes/create">
              <Button variant={ButtonVariantProps.Primary} startIcon={<AddIcon />}>
                ADD Part Type
              </Button>
            </Link>
          )}
        </InlineGroup>
        <PartTypeList />
      </Wrapper>
    </PageContainer>
  );
};
